// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3K3fc","colMaxWidth":"Table_colMaxWidth__2AYLi"};